import { memo } from "react";
import BookingPlanner from "@/components/BookingPlanner";

interface WebshopLeadSectionProps {
  id?: string;
  title?: React.ReactNode;
  description?: string;
  whatsAppMessage?: string;
}

const WebshopLeadSection = ({
  id = "ontdek-omzet",
  title,
  description = "Voor webshops die vastzitten op €20K–€50K omzet per maand. In een gratis strategiesessie doen we een audit van je volledige klantreis en laten we je precies zien waar omzet blijft liggen en hoe je meer uit je bestaande bezoekers en klanten haalt.",

}: WebshopLeadSectionProps) => {
  return (
    <section id={id} data-planner-section className="bg-primary px-4 md:px-12 py-16 md:py-24 w-full">

      <div className="max-w-[1100px] mx-auto">
        {/* Title */}
        <h2 className="text-center text-3xl md:text-5xl lg:text-[3.1rem] font-bold tracking-tight text-white leading-[1.1] mb-6">
          {title || (
            <>
              Ontdek waar jij{" "}
              <span className="text-accent accent-serif">extra omzet</span>{" "}
              laat liggen...
            </>
          )}
        </h2>

        {/* Description */}
        <p className="text-center text-white/70 text-base md:text-lg leading-relaxed max-w-[820px] mx-auto mb-10 md:mb-14">
          {description}
        </p>


        {/* Booking planner */}
        <BookingPlanner />
      </div>
    </section>
  );
};

export default memo(WebshopLeadSection);

